export const individualCTA = {
  heading: "Bring Your Idea to Life with Lunor.Quest",
  description: "Turn your ideas into reality. Whether you're just starting out or looking to collaborate with experts, Lunor.Quest empowers you to launch impactful AI challenges and grow your skills.",
  buttonText: "Start Your Quest Today",
  buttonUrl: "https://app.lunor.quest/challenge/list"
}; 